/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Field_Invite_Code_LabelInputs */

const en_auth_field_invite_code_label = /** @type {(inputs: Auth_Field_Invite_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite code (optional)`)
};

const pl_auth_field_invite_code_label = /** @type {(inputs: Auth_Field_Invite_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kod zaproszenia (opcjonalnie)`)
};

/**
* | output |
* | --- |
* | "Invite code (optional)" |
*
* @param {Auth_Field_Invite_Code_LabelInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_field_invite_code_label = /** @type {((inputs?: Auth_Field_Invite_Code_LabelInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Field_Invite_Code_LabelInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_field_invite_code_label(inputs)
	return en_auth_field_invite_code_label(inputs)
});